import { ReactElement } from 'react'

import FindBancosImpl from 'modules/pagamentos/domain/usecases/FindBancos'
import BancoRepository from 'modules/pagamentos/infra/repositories/BancoRepository'
import NovaConta from 'modules/pagamentos/pages/components/Transferir/components/NovaConta'

export const NovaContaFactory = (): ReactElement => {
  const bancoRepository = new BancoRepository()
  const findAll = new FindBancosImpl(bancoRepository)

  return <NovaConta findAll={findAll} />
}
